/** @format */

import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../../app/store";

export type Action =
  | "card"
  | "lesson"
  | "download"
  | "hint"
  | "answer"
  | "extension";

export interface DeleteModalState {
  action?: Action;
  itemId: string;
  showModal: boolean;
  status: "idle" | "loading" | "failed";
}

const initialState: DeleteModalState = {
  action: undefined,
  itemId: "",
  showModal: false,
  status: "idle",
};

// TODO: Define delete thunks to delete cards/screens/lessons

export const deleteModalSlice = createSlice({
  name: "deleteModal",
  initialState,
  reducers: {
    setAction: (state, action: PayloadAction<Action>) => {
      state.action = action.payload;
    },
    setShowModal: (state, action: PayloadAction<boolean>) => {
      state.showModal = action.payload;
    },
    setShowDeleteModal: (
      state,
      action: PayloadAction<{ action: Action; itemId: string }>,
    ) => {
      state.itemId = action.payload.itemId;
      state.action = action.payload.action;
      state.showModal = true;
    },
  },
});

export const { setAction, setShowModal, setShowDeleteModal } =
  deleteModalSlice.actions;
export const selectAction = () => (state: RootState) =>
  state.deleteModal.action;
export const selectShowModal = () => (state: RootState) =>
  state.deleteModal.showModal;
export const selectItemId = () => (state: RootState) =>
  state.deleteModal.itemId;
export default deleteModalSlice.reducer;
